import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import React from "react";
// import { Col, Row } from "react-bootstrap";
import { StyledGridCol, StyledGridRow } from "@/common/styles";
import { FormContainer } from "../InmateDetails/styles";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import { getOptionsFromRefList } from "@/util/common_function";
import { Divider } from "antd";

const BusinessInformation = ({ bookingsFieldsEnabled }) => {
  return (
    <>
      <Divider
        orientation="left"
        style={{
          borderColor: "#00000080",
        }}
      >
        <span>Business Information</span>
      </Divider>
      <FormContainer>
        {/*<StyledGridRow gutter={16}>*/}
        {/*    <StyledGridCol lg={8}>*/}
        {/*        <FormItem*/}
        {/*            name="enterBusiness"*/}
        {/*            valuePropName="checked"*/}
        {/*            label="Enter business information?"*/}
        {/*            layout="horizontal"*/}
        {/*            className="form-item-checkbox-left"*/}
        {/*        >*/}
        {/*            <Checkbox/>*/}
        {/*        </FormItem>*/}
        {/*    </StyledGridCol>*/}
        {/*</StyledGridRow>*/}
        <StyledGridRow gutter={16}>
          <StyledGridCol lg={7}>
            <FormItem
              name={["businesses", 0, "businessName"]}
              label="Business Name"
            >
              <TextField variant="outlined" />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol lg={7}>
            <FormItem
              name={["businesses", 0, "businessPhone"]}
              label="Business Phone"
            >
              <TextField variant="outlined" />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol lg={7}>
            <FormItem
              name={["businesses", 0, "businessFax"]}
              label="Business Fax"
            >
              <TextField variant="outlined" />
            </FormItem>
          </StyledGridCol>
        </StyledGridRow>
        <StyledGridRow gutter={16}>
          <StyledGridCol lg={3}>
            <FormItem
              name={["businesses", 0, "addresses", 0, "addressStreetNumber"]}
              label="#"
            >
              <TextField variant="outlined" />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol lg={7}>
            <FormItem
              name={["businesses", 0, "addresses", 0, "addressStreet1"]}
              label="Street"
            >
              <TextField variant="outlined" />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol lg={7}>
            <FormItem
              name={["businesses", 0, "addresses", 0, "addressApartmentNumber"]}
              label="Apt #"
            >
              <TextField variant="outlined" />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol lg={7}>
            <FormItem
              name={["businesses", 0, "addresses", 0, "addressStreet2"]}
              label="Street 2"
            >
              <TextField variant="outlined" />
            </FormItem>
          </StyledGridCol>
        </StyledGridRow>
        <StyledGridRow gutter={16}>
          <StyledGridCol lg={3}>
            <FormItem
              name={["businesses", 0, "addresses", 0, "addressCity"]}
              label="City"
            >
              <TextField id="city" />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol lg={6}>
            <FormItem
              name={["businesses", 0, "addresses", 0, "addressState"]}
              label="State"
            >
              <Select
                variant="outlined"
                options={getOptionsFromRefList("USState")}
                disabled={!bookingsFieldsEnabled}
              ></Select>
            </FormItem>
          </StyledGridCol>
          <StyledGridCol lg={6}>
            <FormItem
              name={["businesses", 0, "addresses", 0, "addressZip"]}
              label="Zip Code"
            >
              <TextField variant="outlined" />
            </FormItem>
          </StyledGridCol>
        </StyledGridRow>
      </FormContainer>
    </>
  );
};

export default BusinessInformation;
